import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

import {
  SearchModel,
  TrackChangeDetail,
  TrackChangesResponse
} from '../../types/track-changes/track-changes';
import {Pageable} from '../../types/common/pageable';
import {BasicPersonData} from '../../types/person/basic-person-data';
import {BaseRestService} from '../common/BaseRestService';

@Injectable()
export class TrackChangesRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('changes');
  }

  findTrackChanges(searchModel: SearchModel): Observable<TrackChangesResponse> {
    const obj = {};
    Object.keys(searchModel).forEach(key => {
      if (searchModel[key]) {
       obj[key] = searchModel[key];
      }
    });
    return this.http.post<TrackChangesResponse>(this.getEndpoint(['search']), obj);
  }

  getTrackChangesDetail(id: number): Observable<TrackChangeDetail> {
    return this.http.get<TrackChangeDetail>(this.getEndpoint([String(id)]));
  }


  getConsultants(query: string, page: Pageable): Observable<BasicPersonData[]> {
    const params: HttpParams = new HttpParams()
      .set('query', query)
      .set('size', String(page.size));
    return this.http.get<BasicPersonData[]>(this.getEndpoint(['consultants']), {params});
  }
}
